document.addEventListener("DOMContentLoaded", function () {
  const decline_submit = document.getElementById("decline_submit");
  const decline_select = document.getElementById("decline_select");

  if (decline_submit) {
    decline_submit.setAttribute("disabled", "disabled");

    decline_select.addEventListener("change", function () {
      if (decline_select.selectedIndex == 0) {
        decline_submit.setAttribute("disabled", "disabled");
      } else {
        decline_submit.removeAttribute("disabled", "disabled");
      }
    });
  }
});
